import React, { Suspense } from "react";
import WebMenu from "../Pages/Shared/WebMenu";
import Footer from "../Pages/Shared/Footer";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";

function PublicRoute() {
  const loggedIn = useSelector(
    (state) => state.login?.LoginDetails?.accessToken
  );
  return loggedIn !== undefined ? (
    <Navigate to="/dashboard" />
  ) : (
    <>
      <WebMenu />
      <Suspense
        fallback={
          <div className="loader">
            <CircularProgress sx={{ color: "#86c65a" }} />
          </div>
        }
      >

        <Outlet />
      </Suspense>
      <Footer />
      <button
        className="indicator"
        onClick={() => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }}
      ></button>
    </>
  );
}

export default PublicRoute;
